<ion-row [formGroup]="formGroup">
    <ion-col size-xs="12" size-md="6">
        <ion-item>
            <ion-label position="floating">Name</ion-label>
            <ion-input type="text" formControlName="name" #firstInput></ion-input>
        </ion-item>
    </ion-col>
    <ion-col size-xs="12" size-md="6">
        <ion-item>
            <ion-label position="floating">Phone</ion-label>
            <ion-input type="tel" formControlName="phone" bbPhoneMask inputmode="numeric" maxlength="14" minlength="14">
            </ion-input>
        </ion-item>
    </ion-col>
    <ion-col size-xs="12" size-md="6">
        <ion-item>
            <ion-label position="floating">Subdomain</ion-label>
            <ion-input type="text" formControlName="subdomain"></ion-input>
        </ion-item>
    </ion-col>
</ion-row>
